import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Acquisto, VoceAcquisto} from "../_Models";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";
import {ApiRestService} from "../api-rest.service";

@Component({
  selector: 'app-lavorazioni-edit',
  templateUrl: './lavorazioni-edit.component.html'
})
export class LavorazioniEditComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Input() item: VoceAcquisto;
  @Output() Saved = new EventEmitter<boolean>();
  constructor(
    private ngbActiveModal: NgbActiveModal,
    private ngbModal: NgbModal,
    private clientiApiRest : ClientiApiRestService,
    private apiRestService : ApiRestService,
  ) { }

  ngOnInit(): void {
    this.refresh();
  }
  refresh(){

  }
  save() {
    if(this.item.id){

    } else {

    }
  }
  close() {
    this.ngbActiveModal.dismiss();
  }

}
